import { title } from "process";
import LocalizedStrings from "react-localization";

if (!window.strings2) {
    const strings2 = new LocalizedStrings({
      en: {
        ii_intro_alert: {
            title: "Sign In with Internet Identity",
            body: {
                line1: "Before you continue, you'll be redirected to the ICP blockchain's Internet Identity management screen.",
                line2: `If this is your first time: Choose the "create" option to set up a new Passkey. This Passkey is essential for interacting with PlexiMail as a Smart Contract.`
            },
            footer: {
                next: "Next",
                dont_show_again: "Don't show this again",
                cancel: "Cancel"
            }
        },
        payment: {
          title: "Payment",
          description: "Manage your payment",
          balance: "Balance",
          topup: "Top Up",

          loading_bills: "Loading bills...",
          loading_bill_details: "Loading bill details...",
          paying: "Paying...",
          pay_success: "Payment successful!",
          pay_failed: "Payment failed!",
          pay_failed_description: "Please try again later.",
          pay_cancelled: 'Payment cancelled',
          retry: "Retry",

          unpaid_bills: {
            caption: "",
            col0: "Month",
            col1: "Status",
            col2: "Action",
            pay: "Pay",
            empty: "No bills.",
            empty_description: "You have no unpaid bills.",
            footer: ""
          },
          verification: {
            caption: "Verification",
            send_verification_code: "A verification code will been sent to your phone number.",
            input_verification_code: "Please enter the verification code sent to your phone number.",
            send: "Send Verification Code",
            verify: "Verify",
            resend: "Resend Verification Code",
            resend_verification_code: "A new verification code will been sent to your phone number.",

          },
          bill_details: {
            caption: "",
            col0: "Item",
            col1: "Unit Amount",
            col2: "Quantity",
            pay: "Pay",
            empty: "No Items.",
            empty_description: "This bill is invalid.",
            total: "Total: ",
            footer: ""
          },
          pay: {
            description: "The bill has been generated, click the link below to pay.",
            button: "Click here to pay",
          },
        },
        sidebar: {
            title_mail: "PlexiMail",
            title_contract: "PlexiSign",
            compose: "Compose",
            quicksign: "Quick Sign",
            bulksign: "Bulk Sign",
            inbox: "Inbox",
            sent: "Sent",
            drafts: "Drafts",
            trash: "Trash",
            backup: "Backup",
            contracts: "Contracts",
            settings: "Settings",
            logout: "Logout",
            initiate: "Initiate",
            all: "All",
            initiated: "Initiated",
            signing_round: "Signing Round",
            completed: "Completed",
            secure_archiving: "Secure Archiving",
            contract_utilities: "Contract Utilities",
            folder_name: "Folder Name",
            rename: "Rename",
            delete: "Delete",
            confirm_to_delete: "Confirm to delete",
        },
        help: {
          help: "Help",
          updates: "Updates",
          feedback: "Send Feedback",
        },
        apps: {
            title: "Apps",
            description: "Manage your apps",
            mail: "PlexiMail",
            contract: "PlexiSign",
            contacts: "Contacts",
        },
        profile: {
          language: "Language",
        },
        settings: {
          ai_assistant: {
              title: "Setup AI Assistant",
              description: "Can help you draft contracts and emails"
          },
          toolbar: {
            title: "Show Toolbar",
            description: "You can show or hide the toolbar."
          },
          language: {
            title: "Language"
          }
        },
        contract: {
          back: "Back",
          next: "Next",
          finish: "Finish",
          cancel: "Cancel",
          send: "Send",
          party: "Party",
          moderator: "Moderator",
          name: "Name",
          name_placeholder: "Legal Name",
          email: "Email",
          email_placeholder: "Email address for receiving notifications",
          title: "Title",
          title_placeholder: "Title / Company Name (optional)",
          contract_id: "Contract ID",
          role: "Role",
        }
      },
      zh: {
        ii_intro_alert: {
            title: "使用互联网身份登录",
            body: {
                line1: "在您继续之前，您将被重定向到 ICP 区块链的互联网身份管理屏幕。",
                line2: `如果这是您的第一次：请选择"创建"选项来设置新的 Passkey。此 Passkey 对于与 PlexiMail 作为智能合约进行交互至关重要。`
            },
            footer: {
                next: "下一步",
                dont_show_again: "不再显示",
                cancel: "取消"
            }
        },
        payment: {
          title: "支付",
          description: "管理您的支付",
          balance: "余额",
          topup: "充值",
          loading_bills: "正在加载账单...",
          loading_bill_details: "正在加载账单详情...",
          paying: "支付中...",
          pay_success: "支付成功！",
          pay_failed: "支付失败！",
          pay_failed_description: "请稍后重试。",
          pay_cancelled: '支付已取消',
          retry: "重试",
          unpaid_bills: {
            caption: "",
            col0: "月份",
            col1: "状态",
            col2: "操作",
            pay: "支付",
            empty: "没有账单。",
            empty_description: "您没有未支付的账单。",
            footer: ""
          },
          verification: {
            caption: "验证",
            send_verification_code: "将验证码发送到您的手机号码。",
            input_verification_code: "请输入您收到的验证码。",
            send: "发送验证码",
            verify: "验证",
            resend: "重新发送验证码",
            resend_verification_code: "将新验证码发送到您的手机号码。",
          },
          bill_details: {
            caption: "",
            col0: "项目",
            col1: "单价",
            col2: "数量",
            pay: "支付",
            empty: "没有项目。",
            empty_description: "该账单无效。",
            total: "总价: ",
            footer: ""
          },
          pay: {
            description: "已生成账单，点击下方链接进行支付。",
            button: "点击此处进行支付",
          }
        },
        sidebar: {
            title_mail: "PlexiMail",
            title_contract: "PlexiSign",
            compose: "撰写",
            quicksign: "快速签名",
            bulksign: "批量签名",
            inbox: "收件箱",
            sent: "已发送",
            drafts: "草稿",
            trash: "垃圾箱",
            backup: "备份",
            contracts: "合同",
            settings: "设置",
            logout: "登出",
            initiate: "发起",
            all: "全部",
            initiated: "已发起",
            signing_round: "签名轮",
            completed: "已完成",
            secure_archiving: "安全存档",
            contract_utilities: "合同工具",
            folder_name: "文件夹名称",
            rename: "重命名",
            delete: "删除",
            confirm_to_delete: "确认删除",
        },
        help: {
          help: "帮助",
          updates: "更新",
          feedback: "发送反馈",
        },
        apps: {
            title: "应用程序",
            description: "管理您的应用程序",
            mail: "PlexiMail",
            contract: "PlexiSign",
            contacts: "联系人",
        },
        profile: {
          language: "语言",
        },
        settings: {
          ai_assistant: {
              title: "设置 AI 助手",
              description: "可以帮助您起草合同和电子邮件"
          },
          language: {
            title: "语言"
          }
        },
        contract: {
          back: "返回",
          next: "下一步",
          finish: "完成",
          cancel: "取消",
          send: "发送",
          party: "当事人",
          moderator: "主持人",
          name: "名称",
          name_placeholder: "法定名称",
          email: "电子邮件",
          email_placeholder: "接收通知的电子邮件地址",
          title: "称谓",
          title_placeholder: "称谓/公司名称 (可选)",
          contract_id: "合同 ID",
          role: "角色",
        }
      },
      es: {
        ii_intro_alert: {
            title: "Iniciar sesión con Identidad de Internet",
            body: {
                line1: "Antes de continuar, será redirigido a la pantalla de gestión de Identidad de Internet de la cadena de bloques ICP.",
                line2: `Si es su primera vez: Elija la opción "crear" para configurar una nueva Passkey. Esta Passkey es esencial para interactuar con PlexiMail como un Contrato Inteligente.`
            },
            footer: {
                next: "Siguiente",
                dont_show_again: "No mostrar esto de nuevo",
                cancel: "Cancelar"
            }
        },
        payment: {
          title: "Pago",
          description: "Administre su pago",
          balance: "Saldo",
          topup: "Recarga",
          loading_bills: "Cargando facturas...",
          loading_bill_details: "Cargando detalles de la factura...",
          paying: "Pago en curso...",
          pay_success: "Pago exitoso!",
          pay_failed: "Pago fallido!",
          pay_failed_description: "Por favor, inténtelo de nuevo más tarde.",
          pay_cancelled: 'Pago cancelado',
          retry: "Reintentar",
          unpaid_bills: {
            caption: "",
            col0: "Mes",
            col1: "Estado",
            col2: "Acción",
            pay: "Pagar",
            empty: "No hay facturas.",
            empty_description: "No tienes facturas pendientes.",
            footer: ""
          },
          verification: {
            caption: "Verificación",
            send_verification_code: "Se enviará un código de verificación a su número de teléfono.",
            input_verification_code: "Por favor, ingrese el código de verificación enviado a su número de teléfono.",
            send: "Enviar código de verificación",
            verify: "Verificar",
            resend: "Reenviar código de verificación",
            resend_verification_code: "Se enviará un nuevo código de verificación a su número de teléfono.",
          },
          bill_details: {
            caption: "",
            col0: "Artículo",
            col1: "Cantidad por unidad",
            col2: "Cantidad",
            pay: "Pagar",
            empty: "No hay artículos.",
            empty_description: "Esta factura es inválida.",
            total: "Total: ",
            footer: ""
          }
        },
        sidebar: {
            title_mail: "PlexiMail",
            title_contract: "PlexiSign",
            compose: "Redactar",
            quicksign: "Firma Rápida",
            bulksign: "Firma en Lote",
            inbox: "Bandeja de Entrada",
            sent: "Enviados",
            drafts: "Borradores",
            trash: "Papelera",
            backup: "Respaldo",
            contracts: "Contratos",
            settings: "Configuraciones",
            logout: "Cerrar Sesión",
            initiate: "Iniciar",
            all: "Todos",
            initiated: "Iniciados",
            signing_round: "Ronda de Firma",
            completed: "Completados",
            secure_archiving: "Archivado Seguro",
            contract_utilities: "Utilidades de Contrato",
            folder_name: "Nombre de la Carpeta",
            rename: "Renombrar",
            delete: "Eliminar",
            confirm_to_delete: "Confirmar para eliminar",
        },
        help: {
          help: "Ayuda",
          updates: "Actualizaciones",
          feedback: "Enviar Comentarios",
        },
        apps: {
            title: "Aplicaciones",
            description: "Administre sus aplicaciones",
            mail: "PlexiMail",
            contract: "PlexiSign",
            contacts: "Contactos",
        },
        profile: {
          language: "Idioma",
        },
        settings: {
          ai_assistant: {
              title: "Configurar Asistente de IA",
              description: "Puede ayudarlo a redactar contratos y correos electrónicos"
          },
          language: {
            title: "Idioma"
          }
        },
        contract: {
          back: "Atrás",
          next: "Siguiente",
          finish: "Finalizar",
          cancel: "Cancelar",
          send: "Enviar",
          party: "Parte",
          moderator: "Moderador",
          name: "Nombre",
          name_placeholder: "Nombre Legal",
          email: "Correo Electrónico",
          email_placeholder: "Dirección de correo electrónico para recibir notificaciones",
          title: "Título",
          title_placeholder: "Título / Nombre de la Empresa (opcional)",
          contract_id: "ID del Contrato",
          role: "Rol",
        }
      }
    });
    window.strings2 = strings2;
}

const detectLanguage = () => {
    const lang = navigator.language;
    // console.log("detectLanguage:", lang);
    if (lang.startsWith("zh")) {
      return "zh";
    } else if (lang.startsWith("en")) {
      return "en";
    } else if (lang.startsWith("es")) {
      return "es";
    } else {
      return "en";
    }
  };
  
  let lang = localStorage.getItem("language");
  if (!lang || lang === "") {
    lang = detectLanguage();
  }
  
  if (lang !== "en" && lang !== "zh" && lang !== "es") {
    lang = "en";
  }
  
  window.strings2.setLanguage(lang);
  
  const Strings2 = window.strings2;
  export default Strings2;